import JSONReader from 'utils/reader';
import generateActions from 'utils/actions';
import Album from 'store/models/album';
import Song from 'store/models/song';
import User from 'store/models/user';

export const COUNT_SONG = generateActions('music/COUNT_SONG');
export const GET_RECOMMENDATIONS = generateActions('music/GET_RECOMMENDATIONS');
export const GET_LATEST = generateActions('music/GET_LATEST');
export const GET_POPULAR = generateActions('music/GET_POPULAR');
export const GET_ALBUM = generateActions('music/GET_ALBUM');
export const GET_SONG = generateActions('music/GET_SONG');
export const LIKE_SONG = generateActions('music/LIKE_SONG');
export const LIKE_ALBUM = generateActions('music/LIKE_ALBUM');

/**
 * Request to the server to get recommendations only
 */
export function loadRecommendations() {
  return {
    types: GET_RECOMMENDATIONS,
    promise: {
      url: '/discovers/recommendations',
      reader: (response) => ({
        payload: {
          recommendations: JSONReader({ model: Song }, response.recommendations),
        },
      }),
    },
  };
}

export function loadLatest() {
  return {
    types: GET_LATEST,
    promise: {
      url: '/discovers/latest',
      reader: (response) => ({
        payload: {
          songs: JSONReader({ model: Song }, response.songs),
          podcasts: JSONReader({ model: Song }, response.podcasts),
        },
      }),
    },
  };
}

export function loadPopular() {
  return {
    types: GET_POPULAR,
    promise: {
      url: '/discovers/popular',
      reader: (response) => ({
        payload: {
          songs: JSONReader({ model: Song }, response.songs),
          podcasts: JSONReader({ model: Song }, response.podcasts),
          artists: JSONReader({ model: User }, response.artists),
        },
      }),
    },
  };
}

/**
 * Loads an album by ID
 * @param {Number} id 
 */
export function loadAlbum(id) {
  return {
    types: GET_ALBUM,
    promise: {
      url: `/albums/${id}/published`,
      reader: {
        model: Album,
        root: 'published',
      },
    },
  };
}

/**
 * Loads an song by ID
 * @param {Number} id 
 */
export function loadSong(id) {
  return {
    types: GET_SONG,
    promise: {
      url: `/songs/${id}`,
      reader: {
        model: Song,
        root: 'song',
      },
    },
  };
}

/**
 * Like or unlike the given song
 * @param {Song} song 
 */
export function likeSong(song) {
  return {
    types: LIKE_SONG,
    promise: {
      url: `/songs/${song.id}/likeable`
    }
  }
}

/**
 * Like or unlike the given album
 * @param {Album} album 
 */
export function likeAlbum(album) {
  return {
    types: LIKE_ALBUM,
    promise: {
      url: `/albums/${album.id}/likeable`
    }
  }
}

/**
 * Calls api to save the played song in the database, we need this
 * for analytics when using Amazon S3.
 * @param {Song} song 
 */
export function countPlay(song) {
  return {
    types: COUNT_SONG,
    promise: {
      url: `/songs/${song.id}/play`,
    },
  };
}
